import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { ConsentTemplate } from '@/consent/types/consent-template-api';

/**
 * Single consent template — CG-F4 / PROD-1067.
 *
 *   GET /api/ConsentTemplate/{id} → ConsentTemplate
 *
 * Contract: Scrips.Patient `ConsentTemplateController.Get` (PR #882).
 */
export function useConsentTemplate(id: string | null | undefined) {
  return useQuery({
    queryKey: ['consent-template', id],
    queryFn: ({ signal }) =>
      get<ConsentTemplate>(`/api/ConsentTemplate/${id}`, { signal }),
    enabled: !!id,
    staleTime: 60_000,
  });
}
